import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";
import toast from "react-hot-toast";

import { SocialsData } from "../../content.types";
import { requestUpdateSocials } from "./updateSocials.request";

const useUpdateSocials = (
  options?: MutationOptions<SocialsData, ApiServiceError<ApiError>>
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: requestUpdateSocials,
    ...options,
    onSuccess: (data, ...rest) => {
      toast.success("Socials updated successfully");
      queryClient.setQueryData(["content-socials"], data);
      options?.onSuccess?.(data, ...rest);
    }
  });
};

export default useUpdateSocials;
